<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">BSAC コース申込</h2>
    </div>
    <!-- <button @click="showStoreData">ストアデータ表示</button> -->
    <div id="page-content" class="page-content">
      <h4 class="page-content__input-forms-title">■ お申込者情報の入力</h4>
      <div class="col-sm-8 col-sm-offset-2 page-content__input-forms">
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>氏名（漢字）
          </label>
          <aside>
            <input
              type="text"
              id="name"
              name="name"
              v-model="inputForm.applicant.nameJa"
              @blur="validate()"
              placeholder="例：海野　太郎"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.nameJa
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>氏名（フリガナ）
          </label>
          <aside>
            <input
              type="text"
              id="name_kana"
              name="name_kana"
              v-model="inputForm.applicant.nameKana"
              @blur="validate()"
              placeholder="例：ウミノ　タロウ"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.nameKana
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>氏名（英字）
          </label>
          <aside>
            <input
              type="text"
              id="name_en"
              name="name_en"
              v-model="inputForm.applicant.nameEn"
              @blur="validate()"
              placeholder="例：TARO UMINO"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.nameEn
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>生年月日
          </label>
          <aside class="input-form__date-wrapper">
            <select
              id="bday-year"
              name="bday-year"
              v-model="inputForm.applicant.birthAtYear"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">年</option>
              <option v-for="year in years" v-bind:value="year">{{ year }}年</option>
            </select>
            <select
              id="bday-month"
              name="bday-month"
              v-model="inputForm.applicant.birthAtMonth"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">月</option>
              <option v-for="month in months" v-bind:value="month">{{ month }}月</option>
            </select>
            <select
              id="bday-day"
              name="bday-day"
              v-model="inputForm.applicant.birthAtDay"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">日</option>
              <option v-for="day in days" v-bind:value="day">{{ day }}日</option>
            </select>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.birthAt
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>性別
          </label>
          <aside>
            <label for="gender-male" class="input-form__radio-label">
              <input
                type="radio"
                name="gender"
                v-model="inputForm.applicant.gender"
                @change="validate()"
                value="1"
                id="gender-male"
              />
              <span class="input-form__radio-name">男性</span>
            </label>
            <label for="gender-female" class="input-form__radio-label">
              <input
                type="radio"
                name="gender"
                v-model="inputForm.applicant.gender"
                @change="validate()"
                value="2"
                id="gender-female"
              />
              <span class="input-form__radio-name">女性</span>
            </label>
            <label for="gender-unspecified" class="input-form__radio-label">
              <input
                type="radio"
                name="gender"
                v-model="inputForm.applicant.gender"
                @change="validate()"
                value="0"
                id="gender-unspecified"
              />
              <span class="input-form__radio-name">不特定</span>
            </label>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.gender
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>血液型
          </label>
          <aside>
            <input
              type="text"
              id="blood-type"
              name="blood-type"
              v-model="inputForm.applicant.bloodType"
              @blur="validate()"
              placeholder="例：A"
              autofocus
              required
              class="input-form__textbox input-form__textbox--tiny"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.bloodType
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>郵便番号
            <span class="input-form__label--caution">
              ※ハイフンは不要
            </span>
          </label>
          <aside>
            <input
              type="text"
              id="postal-code"
              name="postal-code"
              inputmode="numeric"
              v-model="inputForm.applicant.postCode"
              @blur="validate()"
              placeholder="例：1010035"
              autofocus
              required
              class="input-form__textbox input-form__textbox--postcode"
            />
            <button
              id="convertAddressButton"
              @click="setAddressByPostcode"
              class="btn btn-secondary input-form__button-convert-address"
            >
              郵便番号から住所をセット
            </button>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.postCode
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>都道府県
          </label>
          <aside>
            <select
              id="address-level1"
              name="address-level1"
              v-model="inputForm.applicant.prefecture"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--tiny"
            >
              <option value="">（選択）</option>
              <option v-for="pref in prefectures" v-bind:value="pref">{{ pref }}</option>
            </select>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.prefecture
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>市区町村、丁目・番地
          </label>
          <aside>
            <input
              type="text"
              id="address-level2"
              name="address-level2"
              v-model="inputForm.applicant.address1st"
              @blur="validate()"
              placeholder="例：千代田区神田紺屋町１３−１"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.address1st
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">建物名など</label>
          <aside>
            <input
              type="text"
              id="address-line2"
              name="address-line2"
              v-model="inputForm.applicant.address2nd"
              @blur="validate()"
              placeholder="例：サンビル4F　402号室"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.address2nd
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">市区町村、丁目・番地（カナ）</label>
          <aside>
            <input
              type="text"
              id="address-level2-kana"
              name="address-level2-kana"
              v-model="inputForm.applicant.address1stKana"
              @blur="validate()"
              placeholder="例：チヨダクカンダコンヤチョウ１３−１"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.address1stKana
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">建物名など（カナ）</label>
          <aside>
            <input
              type="text"
              id="address-line2-kana"
              name="address-line2-kana"
              v-model="inputForm.applicant.address2ndKana"
              @blur="validate()"
              placeholder="例：サンビル4F　402ゴウシツ"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.address2ndKana
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>電話番号
            <span class="input-form__label--caution">
              ※自宅の電話番号または携帯番号をご記入ください
            </span>
          </label>
          <aside>
            <input
              type="text"
              id="tel"
              name="tel"
              v-model="inputForm.applicant.tel"
              @blur="validate()"
              inputmode="tel"
              placeholder="例：0352975656 ※ハイフンは不要"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.applicant.tel }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">携帯番号</label>
          <aside>
            <input
              type="text"
              id="mobile"
              name="mobile"
              v-model="inputForm.applicant.mobile"
              @blur="validate()"
              inputmode="tel"
              placeholder="例：09012345678 ※ハイフンは不要"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.mobile
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>e-mail（PC・携帯）
          </label>
          <aside>
            <input
              type="text"
              id="email"
              name="email"
              v-model="inputForm.applicant.email"
              @blur="validate()"
              inputmode="email"
              placeholder="例：taro_umino@bsac.jp"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.applicant.email }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>来店予定日
          </label>
          <aside class="input-form__date-wrapper">
            <select
              id="vday-year"
              name="vday-year"
              v-model="inputForm.applicant.visitAtYear"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">年</option>
              <option v-for="year in visitYears" v-bind:value="year">{{ year }}年</option>
            </select>
            <select
              id="vday-month"
              name="vday-month"
              v-model="inputForm.applicant.visitAtMonth"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">月</option>
              <option v-for="month in months" v-bind:value="month">{{ month }}月</option>
            </select>
            <select
              id="vday-day"
              name="vday-day"
              v-model="inputForm.applicant.visitAtDay"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">日</option>
              <option v-for="day in visitDays" v-bind:value="day">{{ day }}日</option>
            </select>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.visitAt
          }}</span>
        </section>
      </div>
      <h4 class="page-content__input-forms-title">■ 緊急連絡先情報の入力</h4>
      <div class="col-sm-8 col-sm-offset-2 page-content__input-forms">
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>氏名
          </label>
          <aside>
            <input
              type="text"
              id="emg-name"
              name="emg-name"
              v-model="inputForm.emergency.name"
              @blur="validate()"
              placeholder="例：海野　太郎"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.emergency.name }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>氏名（カナ）
          </label>
          <aside>
            <input
              type="text"
              id="emg-name-kana"
              name="emg-name-kana"
              v-model="inputForm.emergency.nameKana"
              @blur="validate()"
              placeholder="例：ウミノ　タロウ"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">
            {{ this.error.emergency.nameKana }}
          </span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">申込者との続柄</label>
          <aside>
            <input
              type="text"
              id="emg-family-relationship"
              name="emg-family-relationship"
              v-model="inputForm.emergency.familyRelationship"
              @blur="validate()"
              placeholder="例：夫、妻、父、母、子"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.emergency.familyRelationship
          }}</span>
        </section>
        <section class="page-content__form-group">
          <button
              id="copyAddressButton"
              @click="copyAddressFromApplicantToEmergency"
              class="btn btn-info input-form__button-copy-address"
            >
              お申込者情報から郵便番号と住所をコピー
            </button>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>郵便番号
            <span class="input-form__label--caution">
              ※ハイフンは不要
            </span>
          </label>
          <aside>
            <input
              type="text"
              id="emg-postal-code"
              name="emg-postal-code"
              v-model="inputForm.emergency.postCode"
              @blur="validate()"
              inputmode="numeric"
              placeholder="例：1010035"
              autofocus
              required
              class="input-form__textbox input-form__textbox--postcode"
            />
            <button
              id="convertAddressButton"
              @click="setAddressByPostcodeEmg"
              class="btn btn-secondary input-form__button-convert-address"
            >
              郵便番号から住所をセット
            </button>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.emergency.postCode
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>都道府県
          </label>
          <aside>
            <select
              id="emg-address-level1"
              name="emg-address-level1"
              v-model="inputForm.emergency.prefecture"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--tiny"
            >
              <option value="">（選択）</option>
              <option v-for="pref in prefectures" v-bind:value="pref">{{ pref }}</option>
            </select>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.emergency.prefecture
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>市区町村、丁目・番地
          </label>
          <aside>
            <input
              type="text"
              id="emg-address-level2"
              name="emg-address-level2"
              v-model="inputForm.emergency.address1st"
              @blur="validate()"
              placeholder="例：千代田区神田紺屋町１３−１"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.emergency.address1st
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">建物名など</label>
          <aside>
            <input
              type="text"
              id="emg-address-line2"
              name="emg-address-line2"
              v-model="inputForm.emergency.address2nd"
              @blur="validate()"
              placeholder="例：サンビル4F　402号室"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">
            {{ this.error.emergency.address2nd }}
          </span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">市区町村、丁目・番地（カナ）</label>
          <aside>
            <input
              type="text"
              id="emg-address-level2-kana"
              name="emg-address-level2-kana"
              v-model="inputForm.emergency.address1stKana"
              @blur="validate()"
              placeholder="例：チヨダクカンダコンヤチョウ１３−１"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">
            {{ this.error.emergency.address1stKana }}
          </span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">建物名など（カナ）</label>
          <aside>
            <input
              type="text"
              id="emg-address-line2-kana"
              name="emg-address-line2-kana"
              v-model="inputForm.emergency.address2ndKana"
              @blur="validate()"
              placeholder="例：サンビル4F　402ゴウシツ"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">
            {{ this.error.emergency.address2ndKana }}
          </span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>電話番号
            <span class="input-form__label--caution">
              ※自宅の電話番号または携帯番号をご記入ください
            </span>
          </label>
          <aside>
            <input
              type="text"
              id="emg-tel"
              name="emg-tel"
              v-model="inputForm.emergency.tel"
              @blur="validate()"
              inputmode="tel"
              placeholder="例：0352975656 ※ハイフンは不要"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.emergency.tel }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">携帯番号</label>
          <aside>
            <input
              type="text"
              id="emg-mobile"
              name="emg-mobile"
              v-model="inputForm.emergency.mobile"
              @blur="validate()"
              inputmode="tel"
              placeholder="例：09012345678 ※ハイフンは不要"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.emergency.mobile
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">e-mail（PC・携帯）</label>
          <aside>
            <input
              type="text"
              id="emg-email"
              name="emg-email"
              v-model="inputForm.emergency.email"
              @blur="validate()"
              inputmode="email"
              placeholder="例：taro_umino@bsac.jp"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.emergency.email }}</span>
        </section>
      </div>
      <h4 class="page-content__input-forms-title page-content__input-forms-title--small"></h4>
      <div class="col-sm-8 col-sm-offset-2 page-content__input-forms">
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>
            受講予定ダイブセンター/インストラクター
          </label>
          <p class="input-form__label-title--submessage">
            <ul>
              <li type="disc" class="input-form__label-title--caution">受講されるショップ名を選んでください。</li>
              <li type="disc">ドロップダウンリストに受講予定のショップ名が無い場合は、一番下の「その他」を選択して、受講するインストラクター名とインストラクターのメールアドレスをご入力ください。</li>
            </ul>
          </p>
          <aside>
            <select
              id="dive-center-name"
              name="dive-center-name"
              v-model="inputForm.diveCenter.id"
              @blur="
                setDiveCenterInfo();
                validate();
              "
              class="input-form__selectbox input-form__selectbox"
            >
              <option value="">（選択）</option>
              <optgroup v-for="prefecture in shopsByPrefecture" :label="prefecture.name">
                <option v-for="shop in prefecture.shops" v-bind:value="shop.id">
                  {{ shop.name }}
                </option>
              </optgroup>
            </select>
          </aside>
          <span class="input-form__label-validation-message">
            {{ this.error.diveCenter.id }}
          </span>
        </section>
        <section v-show="inputForm.diveCenter.id === -1" class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>
            インストラクター名
          </label>
          <aside style="margin-top: 0.5rem">
            <input
              type="text"
              id="dive-center-name-others"
              name="dive-center-name-others"
              v-model="inputForm.diveCenter.others"
              @blur="validate()"
              placeholder="例：海野　太郎"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">
            {{ this.error.diveCenter.name }}
          </span>
        </section>
        <section v-show="inputForm.diveCenter.id === -1" class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>
            インストラクター メールアドレス
          </label>
          <aside>
            <input
              type="text"
              id="dive-center-email"
              name="dive-center-email"
              v-model="inputForm.diveCenter.othersEmail"
              @blur="validate()"
              inputmode="email"
              placeholder="例：taro_umino@bsac.jp"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">
            {{ this.error.diveCenter.othersEmail }}
          </span>
        </section>
      </div>
      <h4 class="page-content__input-forms-title page-content__input-forms-title--small">
        ■ 以下の情報は器材をレンタルする際に必要な情報となります
      </h4>
      <div class="col-sm-8 col-sm-offset-2 page-content__input-forms">
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">身長（cm）</label>
          <aside>
            <input
              type="text"
              id="height"
              name="height"
              v-model="inputForm.rental.height"
              @blur="validate()"
              placeholder="例：170.5"
              autofocus
              required
              class="input-form__textbox input-form__textbox--tiny"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.rental.height }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">体重（kg）</label>
          <aside>
            <input
              type="text"
              id="weight"
              name="weight"
              v-model="inputForm.rental.weight"
              @blur="validate()"
              placeholder="例：60.5"
              autofocus
              required
              class="input-form__textbox input-form__textbox--tiny"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.rental.weight }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">靴のサイズ（cm）</label>
          <aside>
            <input
              type="text"
              id="shoe_size"
              name="shoe_size"
              v-model="inputForm.rental.shoeSize"
              @blur="validate()"
              placeholder="例：25.5"
              autofocus
              required
              class="input-form__textbox input-form__textbox--tiny"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.rental.shoeSize }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">視力（右）</label>
          <aside>
            <input
              type="text"
              id="optic_right"
              name="optic_right"
              v-model="inputForm.rental.opticRight"
              @blur="validate()"
              placeholder="例：1.0"
              autofocus
              required
              class="input-form__textbox input-form__textbox--tiny"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.rental.opticRight
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">視力（左）</label>
          <aside>
            <input
              type="text"
              id="optic_left"
              name="optic_left"
              v-model="inputForm.rental.opticLeft"
              @blur="validate()"
              placeholder="例：1.0"
              autofocus
              required
              class="input-form__textbox input-form__textbox--tiny"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.rental.opticLeft
          }}</span>
        </section>
      </div>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <router-link v-show="isSubmit" to="/consent" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              受講了解事項画面へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Core as YubinBangoCore } from 'yubinbango-core2';
import selectboxValues from 'utils/selectbox-values';
import selections from 'constant/selections';
import validations from 'utils/validations';

export default {
  /**
   * 次の画面に遷移する前に実行する
   */
  beforeRouteLeave(to, from, next) {
    this.validate();
    next(this.isSubmit); // 入力値検証がNGの場合は遷移できない
  },
  computed: {
    /**
     * 日リストを取得する
     */
    days: function () {
      return selectboxValues.getDays({
        year: this.inputForm.applicant.birthAtYear,
        month: this.inputForm.applicant.birthAtMonth,
      });
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      let result = true;
      result &= this.error.applicant.address1st === null;
      result &= this.error.applicant.address1stKana === null;
      result &= this.error.applicant.address2nd === null;
      result &= this.error.applicant.address2ndKana === null;
      result &= this.error.applicant.birthAt === null;
      result &= this.error.applicant.bloodType === null;
      result &= this.error.applicant.email === null;
      result &= this.error.applicant.gender === null;
      result &= this.error.applicant.mobile === null;
      result &= this.error.applicant.nameEn === null;
      result &= this.error.applicant.nameKana === null;
      result &= this.error.applicant.nameJa === null;
      result &= this.error.applicant.postCode === null;
      result &= this.error.applicant.prefecture === null;
      result &= this.error.applicant.tel === null;

      result &= this.error.diveCenter.id === null;
      result &= this.error.diveCenter.name === null;
      result &= this.error.diveCenter.othersEmail === null;

      result &= this.error.emergency.address1st === null;
      result &= this.error.emergency.address1stKana === null;
      result &= this.error.emergency.address2nd === null;
      result &= this.error.emergency.address2ndKana === null;
      result &= this.error.emergency.email === null;
      result &= this.error.emergency.familyRelationship === null;
      result &= this.error.emergency.mobile === null;
      result &= this.error.emergency.name === null;
      result &= this.error.emergency.nameKana === null;
      result &= this.error.emergency.postCode === null;
      result &= this.error.emergency.prefecture === null;
      result &= this.error.emergency.tel === null;

      //console.log('result:' + JSON.stringify(this.error));
      if (result) this.saveDataInStore();
      return result;
    },
    /**
     * 月リストを取得する
     */
    months: function () {
      return selectboxValues.getMonths();
    },
    /**
     * 都道府県リストを取得する
     */
    prefectures: function () {
      return selectboxValues.prefectures;
    },
    /**
     * ショップリストを取得する
     */
    shops: function () {
      // return this.$store.getters['shop/shopNames'];
      return this.$store.getters['shop/shopList'];
    },
    /**
     * 都道府県別ショップリストを取得する
     */
    shopsByPrefecture: function () {
      return this.$store.getters['shop/shopListByPrefecture'];
    },
    /**
     * 年リストを取得する
     */
    years: function () {
      return selectboxValues.getYears(120);
    },
    /**
     * 来店日の日リストを取得する
     */
    visitDays: function () {
      return selectboxValues.getDays({
        year: this.inputForm.applicant.visitAtYear,
        month: this.inputForm.applicant.visitAtMonth,
      });
    },
    /**
     * 来店日の年リストを取得する
     */
    visitYears: function () {
      return selections.scheduledYears();
    },
  },
  data() {
    return {
      /**
       * オートフィル検出用タイマー
       */
      autofillTimer: null,
      /**
       * 入力内容
       */
      inputForm: {
        applicant: {
          address1st: null,
          address1stKana: null,
          address2nd: null,
          address2ndKana: null,
          birthAtDay: '',
          birthAtMonth: '',
          birthAtYear: '',
          bloodType: null,
          email: null,
          gender: '1', // デフォルトで「男性」にチェックする
          mobile: null,
          nameEn: null,
          nameKana: null,
          nameJa: null,
          postCode: null,
          prefecture: '',
          tel: null,
          visitAtDay: '',
          visitAtMonth: '',
          visitAtYear: '',
        },
        diveCenter: {
          id: '',
          name: '',
          email: '',
          others: '',
          othersEmail: '',
        },
        emergency: {
          address1st: null,
          address1stKana: null,
          address2nd: null,
          address2ndKana: null,
          email: null,
          familyRelationship: null,
          mobile: null,
          name: null,
          nameKana: null,
          postCode: null,
          prefecture: '',
          tel: null,
        },
        rental: {
          height: null,
          opticLeft: null,
          opticRight: null,
          shoeSize: null,
          weight: null,
        },
      },
      /**
       * エラーメッセージ
       */
      error: {
        applicant: {
          address1st: '',
          address1stKana: '',
          address2nd: null, // 任意入力項目は入力チェックOK状態に設定する
          address2ndKana: null, // 任意入力項目は入力チェックOK状態に設定する
          birthAt: '',
          bloodType: '',
          email: '',
          gender: null, // 初期表示するため入力チェックOK状態に設定する
          mobile: '電話番号か携帯番号をご記入ください', // 任意入力項目は入力チェックOK状態に設定する
          nameEn: '',
          nameKana: '',
          nameJa: '',
          postCode: '',
          prefecture: '',
          tel: '電話番号か携帯番号をご記入ください',
          visitAt: '',
        },
        diveCenter: {
          id: '',
          name: '',
          othersEmail: '',
        },
        emergency: {
          address1st: '',
          address1stKana: '',
          address2nd: null, // 任意入力項目は入力チェックOK状態に設定する
          address2ndKana: null, // 任意入力項目は入力チェックOK状態に設定する
          email: null, // 任意入力項目は入力チェックOK状態に設定する
          familyRelationship: '',
          mobile: '電話番号か携帯番号をご記入ください', // 任意入力項目は入力チェックOK状態に設定する
          name: '',
          nameKana: '',
          postCode: '',
          prefecture: '',
          tel: '電話番号か携帯番号をご記入ください',
        },
        rental: {
          height: '',
          opticLeft: '',
          opticRight: '',
          shoeSize: '',
          weight: '',
        },
      },
    };
  },
  methods: {
    /**
     * お申込者情報から緊急連絡先情報に郵便番号と住所をコピーボタン
     */
    copyAddressFromApplicantToEmergency: function() {
      this.inputForm.emergency.postCode = this.inputForm.applicant.postCode;
      this.inputForm.emergency.prefecture = this.inputForm.applicant.prefecture;
      this.inputForm.emergency.address1st = this.inputForm.applicant.address1st;
      this.inputForm.emergency.address1stKana = this.inputForm.applicant.address1stKana;
      this.inputForm.emergency.address2nd = this.inputForm.applicant.address2nd;
      this.inputForm.emergency.address2ndKana = this.inputForm.applicant.address2ndKana;
      this.validate();
    },
    /**
     * 入力値をストアから取得する
     */
    getDataFromStore: function () {
      this.inputForm.applicant = this.$store.getters['courseApplication/applicant'];
      this.inputForm.diveCenter = this.$store.getters['courseApplication/diveCenter'];
      this.inputForm.emergency = this.$store.getters['courseApplication/emergency'];
      this.inputForm.rental = this.$store.getters['courseApplication/rental'];
    },
    /**
     * 入力値をストアに保存する
     */
    saveDataInStore: function () {
      this.$store.commit('courseApplication/setApplication', this.inputForm);
    },
    /**
     * 郵便番号から住所を取得する
     */
    getAddressByPostcode: async function (postcoce) {
      let adr = { prefecture: null, address1st: null };
      await new YubinBangoCore(postcoce, (address) => {
        adr.prefecture = address.region;
        adr.address1st = address.locality + address.street;
      });
      // 念のためスリープする
      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      await sleep(300);
      return adr;
    },
    /**
     * 郵便番号から住所を取得しテキストボックスにセットする
     */
    setAddressByPostcode: async function () {
      let address = await this.getAddressByPostcode(this.inputForm.applicant.postCode);
      this.inputForm.applicant.prefecture = address.prefecture;
      this.inputForm.applicant.address1st = address.address1st;
      this.validate();
    },
    /**
     * 緊急連絡先：郵便番号から住所を取得しテキストボックスにセットする
     */
    setAddressByPostcodeEmg: async function () {
      let address = await this.getAddressByPostcode(this.inputForm.emergency.postCode);
      this.inputForm.emergency.prefecture = address.prefecture;
      this.inputForm.emergency.address1st = address.address1st;
      this.validate();
    },
    /**
     * ダイブセンター情報をセットする
     */
    setDiveCenterInfo: function () {
      for (const shop of this.shops) {
        if (this.inputForm.diveCenter.id === shop.id) {
          this.inputForm.diveCenter.name = shop.name;
          if (!process.env.ELEARNING_MAIL_DIVE_CENTER_TO) {
            this.inputForm.diveCenter.email = shop.email;
          } else {
            this.inputForm.diveCenter.email = process.env.ELEARNING_MAIL_DIVE_CENTER_TO;
          }
          this.inputForm.diveCenter.others = '';
          this.inputForm.diveCenter.othersEmail = '';
          return;
        }
      }
      this.inputForm.diveCenter.id = -1;
      this.inputForm.diveCenter.name = '';
      this.inputForm.diveCenter.email = '';
    },
    /**
     * オートフィル検出のための定期チェック
     */
    startAutofillDetection() {
      this.autofillTimer = setInterval(() => {
        this.validate();
      }, 1000);
    },
    /**
     * 定期チェックを停止
     */
    stopAutofillDetection() {
      if (this.autofillTimer) {
        clearInterval(this.autofillTimer);
        this.autofillTimer = null;
      }
    },
    /**
     * 入力値を検証する
     */
    validate: function () {
      /**
       * お申込者情報・氏名（漢字）
       */
      this.error.applicant.nameJa = validations.validateChars({
        value: this.inputForm.applicant.nameJa,
        size: 50,
        requiredCheck: true,
      });
      /**
       * お申込者情報・氏名（フリガナ）
       */
      this.error.applicant.nameKana = validations.validateChars({
        value: this.inputForm.applicant.nameKana,
        size: 50,
        requiredCheck: true,
      });
      /**
       * お申込者情報・氏名（英字）
       */
      this.error.applicant.nameEn = validations.validateChars({
        value: this.inputForm.applicant.nameEn,
        size: 50,
        requiredCheck: true,
      });
      /**
       * お申込者情報・生年月日
       */
      this.error.applicant.birthAt = validations.validateDate({
        value: {
          year: this.inputForm.applicant.birthAtYear,
          month: this.inputForm.applicant.birthAtMonth,
          day: this.inputForm.applicant.birthAtDay,
        },
        requiredCheck: true,
      });
      /**
       * お申込者情報・性別
       */
      this.error.applicant.bloodType = validations.validateChars({
        value: this.inputForm.applicant.gender,
        size: 1,
        requiredCheck: true,
      });
      /**
       * お申込者情報・血液型
       */
      this.error.applicant.bloodType = validations.validateChars({
        value: this.inputForm.applicant.bloodType,
        size: 20,
        requiredCheck: true,
      });
      /**
       * お申込者情報・郵便番号
       */
      this.error.applicant.postCode = validations.validateChars({
        value: this.inputForm.applicant.postCode,
        size: 7,
        requiredCheck: true,
        numerickCheck: true,
      });
      /**
       * お申込者情報・都道府県
       */
      this.error.applicant.prefecture = validations.validateChars({
        value: this.inputForm.applicant.prefecture,
        size: 10,
        requiredCheck: true,
      });
      /**
       * お申込者情報・住所１（市区町村、丁目・番地）
       */
      this.error.applicant.address1st = validations.validateChars({
        value: this.inputForm.applicant.address1st,
        size: 100,
        requiredCheck: true,
      });
      /**
       * お申込者情報・住所１（市区町村、丁目・番地）（カナ）
       */
      this.error.applicant.address1stKana = validations.validateChars({
        value: this.inputForm.applicant.address1stKana,
        size: 100,
        requiredCheck: false,
      });
      /**
       * お申込者情報・住所２（建物名など）
       */
      this.error.applicant.address2nd = validations.validateChars({
        value: this.inputForm.applicant.address2nd,
        size: 100,
        requiredCheck: false,
      });
      /**
       * お申込者情報・住所２（建物名など）（カナ）
       */
      this.error.applicant.address2ndKana = validations.validateChars({
        value: this.inputForm.applicant.address2ndKana,
        size: 100,
        requiredCheck: false,
      });
      /**
       * お申込者情報・電話番号、携帯番号
       */
      this.error.applicant.tel = validations.validateChars({
        value: this.inputForm.applicant.tel,
        size: 20,
        numericHyphenCheck: true,
        requiredCheck: true,
      });
      this.error.applicant.mobile = validations.validateChars({
        value: this.inputForm.applicant.mobile,
        size: 20,
        numericHyphenCheck: true,
        requiredCheck: false,
      });
      // if (this.error.applicant.tel !== null && this.error.applicant.mobile !== null) return;
      // if (
      //   (this.inputForm.applicant.tel === null || this.inputForm.applicant.tel === '') &&
      //   (this.inputForm.applicant.mobile === null || this.inputForm.applicant.mobile === '')
      // ) {
      //   this.error.applicant.tel = '電話番号か携帯番号をご記入ください';
      //   this.error.applicant.mobile = '電話番号か携帯番号をご記入ください';
      // }
      /**
       * お申込者情報・e-mail
       */
      this.error.applicant.email = validations.validateChars({
        value: this.inputForm.applicant.email,
        size: 100,
        emailCheck: true,
        requiredCheck: true,
      });
      /**
       * お申込者情報・来店予定日
       */
      this.error.applicant.visitAt = validations.validateDate({
        value: {
          year: this.inputForm.applicant.visitAtYear,
          month: this.inputForm.applicant.visitAtMonth,
          day: this.inputForm.applicant.visitAtDay,
        },
        requiredCheck: false,
      });
      /**
       * 緊急連絡先情報・氏名
       */
      this.error.emergency.name = validations.validateChars({
        value: this.inputForm.emergency.name,
        size: 50,
        requiredCheck: true,
      });
      /**
       * 緊急連絡先情報・氏名（カナ）
       */
      this.error.emergency.nameKana = validations.validateChars({
        value: this.inputForm.emergency.nameKana,
        size: 50,
        requiredCheck: true,
      });
      /**
       * 緊急連絡先情報・申込者との続柄
       */
      this.error.emergency.familyRelationship = validations.validateChars({
        value: this.inputForm.emergency.familyRelationship,
        size: 10,
        requiredCheck: false,
      });
      /**
       * 緊急連絡先情報・郵便番号
       */
      this.error.emergency.postCode = validations.validateChars({
        value: this.inputForm.emergency.postCode,
        size: 7,
        requiredCheck: true,
        numerickCheck: true,
      });
      /**
       * 緊急連絡先情報・都道府県
       */
      this.error.emergency.prefecture = validations.validateChars({
        value: this.inputForm.emergency.prefecture,
        size: 10,
        requiredCheck: true,
      });
      /**
       * 緊急連絡先情報・住所１（市区町村、丁目・番地）
       */
      this.error.emergency.address1st = validations.validateChars({
        value: this.inputForm.emergency.address1st,
        size: 100,
        requiredCheck: true,
      });
      /**
       * 緊急連絡先情報・住所１（市区町村、丁目・番地）（カナ）
       */
      this.error.emergency.address1stKana = validations.validateChars({
        value: this.inputForm.emergency.address1stKana,
        size: 100,
        requiredCheck: false,
      });
      /**
       * 緊急連絡先情報・住所２（建物名など）
       */
      this.error.emergency.address2nd = validations.validateChars({
        value: this.inputForm.emergency.address2nd,
        size: 100,
        requiredCheck: false,
      });
      /**
       * 緊急連絡先情報・住所２（建物名など）（カナ）
       */
      this.error.emergency.address2ndKana = validations.validateChars({
        value: this.inputForm.emergency.address2ndKana,
        size: 100,
        requiredCheck: false,
      });
      /**
       * 緊急連絡先情報・電話番号、携帯番号
       */
      this.error.emergency.tel = validations.validateChars({
        value: this.inputForm.emergency.tel,
        size: 20,
        numericHyphenCheck: true,
        requiredCheck: true,
      });
      this.error.emergency.mobile = validations.validateChars({
        value: this.inputForm.emergency.mobile,
        size: 20,
        numericHyphenCheck: true,
        requiredCheck: false,
      });
      // if (this.error.emergency.tel !== null && this.error.emergency.mobile !== null) return;
      // if (
      //   (this.inputForm.emergency.tel === null || this.inputForm.emergency.tel === '') &&
      //   (this.inputForm.emergency.mobile === null || this.inputForm.emergency.mobile === '')
      // ) {
      //   this.error.emergency.tel = '電話番号か携帯番号をご記入ください';
      //   this.error.emergency.mobile = '電話番号か携帯番号をご記入ください';
      // }
      /**
       * 緊急連絡先情報・e-mail.
       */
      this.error.emergency.email = validations.validateChars({
        value: this.inputForm.emergency.email,
        size: 100,
        emailCheck: true,
        requiredCheck: false,
      });
      /**
       * ダイブセンター
       */
       this.error.diveCenter.id = validations.validateChars({
        value: this.inputForm.diveCenter.id,
        size: 50,
        requiredCheck: true,
      });
      /**
       * その他ダイブセンター/インストラクター名
       */
      this.error.diveCenter.name = validations.validateChars({
        value: this.inputForm.diveCenter.others,
        size: 50,
        requiredCheck: this.inputForm.diveCenter.id === -1,
      });
      /**
       * その他ダイブセンター/インストラクター メールアドレス
       */
      this.error.diveCenter.othersEmail = validations.validateChars({
        value: this.inputForm.diveCenter.othersEmail,
        size: 100,
        emailCheck: true,
        requiredCheck: this.inputForm.diveCenter.id === -1,
      });
      /**
       * 身長
       */
      this.error.rental.height = validations.validateDecimal({
        value: this.inputForm.rental.height,
        precision: 3,
        scale: 1,
        requiredCheck: false,
      });
      /**
       * 体重
       */
      this.error.rental.weight = validations.validateDecimal({
        value: this.inputForm.rental.weight,
        precision: 3,
        scale: 1,
        requiredCheck: false,
      });
      /**
       * 靴のサイズ
       */
      this.error.rental.shoeSize = validations.validateDecimal({
        value: this.inputForm.rental.shoeSize,
        precision: 2,
        scale: 1,
        requiredCheck: false,
      });
      /**
       * 視力（右）
       */
      this.error.rental.opticRight = validations.validateDecimal({
        value: this.inputForm.rental.opticRight,
        precision: 1,
        scale: 2,
        requiredCheck: false,
      });
      /**
       * 視力（左）
       */
      this.error.rental.opticLeft = validations.validateDecimal({
        value: this.inputForm.rental.opticLeft,
        precision: 1,
        scale: 2,
        requiredCheck: false,
      });
    },
  },
  mounted() {
    this.getDataFromStore();
    this.validate({ all: true });
    this.shopsByPrefecture;
    this.startAutofillDetection();
  },
  beforeUnmount() {
    this.stopAutofillDetection();
  }
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/input-form-radio.scss';
@import 'stylesheets/input-form.scss';
@import 'stylesheets/page.scss';

/*
参考: https://www.jungleocean.com/programming/190318form-technic
*/

.page-content__input-forms {
  width: 80%;
  min-width: 300px;
  max-width: 500px;
  height: auto;
  margin: 0 auto 0 auto;
  padding: 1rem 1rem 1rem 1rem;

  border-style: solid;
  border-width: 0.5px;

  &-title {
    width: 80%;
    min-width: 300px;
    max-width: 500px;
    margin: 1rem auto 0.5rem auto;

    font-size: 1.2rem;
    font-weight: bold;
    //white-space: nowrap;
    overflow-wrap: break-word;

    &--small {
      font-size: 1rem;
    }
  }
}
</style>
